import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import Container from './Container';

const Wrap = styled.div`
	padding: 8rem 0 0;
	margin: 0 auto;
	max-width: 75rem;
	text-align: center;

	${rmq('ml')} {
		padding: 4rem 0 0;
	}

	&::before {
		content: '';
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		display: block;
		height: 1px;
		background: linear-gradient(
			to right,
			rgba(227, 231, 235, 0.1) 0px,
			rgba(227, 231, 235, 0.6) 50%,
			rgba(227, 231, 235, 0.1) 100%
		);
	}
`;

const Title = styled.h2`
	font-family: ${props => props.theme.f1};
	font-size: 3.6rem;
	line-height: 1.278;
	letter-spacing: -0.02rem;
	margin-bottom: 1.6rem;

	${rmq('ml')} {
		font-size: 2.5rem;
	}
`;

export default ({ children }) => (
	<Container>
		<Wrap>
			<Title>{children}</Title>
		</Wrap>
	</Container>
);
